import { api } from './client'
import type { components } from './generated/schema'

// Types come from the generated OpenAPI schema (pnpm api:types) so a BE
// contract change surfaces here at compile time instead of at runtime.
export type IrrigationDevice = components['schemas']['IrrigationDevice']
export type IrrigationDeviceRenameRequest =
    components['schemas']['IrrigationDeviceRenameRequest']
export type IrrigationPumpResult = components['schemas']['IrrigationPumpResult']
export type IrrigationRun = components['schemas']['IrrigationRun']
export type IrrigationScheduleConfig =
    components['schemas']['IrrigationScheduleConfig']
export type IrrigationScheduleView =
    components['schemas']['IrrigationScheduleView']
export type IrrigationScheduleSaveRequest =
    components['schemas']['IrrigationScheduleSaveRequest']
export type IrrigationSession = components['schemas']['IrrigationSession']
export type IrrigationSchedulePreview =
    components['schemas']['IrrigationSchedulePreview']
export type IrrigationCreateRunRequest =
    components['schemas']['IrrigationCreateRunRequest']

const device = (id: string) => `/irrigation/devices/${encodeURIComponent(id)}`

export const irrigationDevicesApi = {
    list: () => api.get<Array<IrrigationDevice>>('/irrigation/devices'),
    // Chỉ đổi tên hiển thị trong ERP, không gửi gì tới SmartLab hay máy bơm.
    // name rỗng = dùng lại tên gốc SmartLab.
    rename: (id: string, body: IrrigationDeviceRenameRequest) =>
        api.put<void>(`${device(id)}/name`, body),
    // Tắt bơm THẬT ngay. Chỉ gọi sau khi người dùng xác nhận trong hộp thoại.
    stop: (id: string) => api.post<IrrigationPumpResult>(`${device(id)}/stop`),
    // Tưới ngay (không start_at) sẽ bật bơm THẬT — chỉ gọi sau khi xác nhận.
    createRun: (id: string, body: IrrigationCreateRunRequest) =>
        api.post<IrrigationRun>(`${device(id)}/runs`, body),
    listRuns: (id: string) =>
        api.get<Array<IrrigationRun>>(`${device(id)}/runs`),
    cancelRun: (runId: string) =>
        api.delete<void>(`/irrigation/runs/${encodeURIComponent(runId)}`),
    getSchedule: (id: string) =>
        api.get<IrrigationScheduleView>(`${device(id)}/schedule`),
    saveSchedule: (id: string, body: IrrigationScheduleSaveRequest) =>
        api.put<IrrigationScheduleView>(`${device(id)}/schedule`, body),
    // Quy tắc lịch nằm ở backend: xem trước cũng do backend tính.
    previewSchedule: (config: IrrigationScheduleConfig) =>
        api.post<IrrigationSchedulePreview>(
            '/irrigation/schedule-preview',
            config,
        ),
}
